export type PromoTag = {
  label: string;
  background_color?: string;
  color?: string;
};

type PromoTagPascal = { BackgroundColour: string; Label: string; Colour: string };
type PromoTagLowerSnake = { background_color: string; label: string; color: string };

const PROMOS_TO_HIDE: Array<string> = [];

export const getPromoTags = (promoTags?: Array<PromoTagPascal | PromoTagLowerSnake> | null): Array<PromoTag> | null => {
  if (!promoTags) return [];

  return promoTags
    .map((tag: any) => {
      const background_color = 'background_color' in tag ? tag.background_color : tag.BackgroundColour;
      const color = 'color' in tag ? tag.color : tag.Colour;

      return {
        label: ('label' in tag ? tag.label : tag.Label) as string,
        ...(background_color ? { background_color } : {}),
        ...(color ? { color } : {}),
      };
    })
    .filter((tag: any) => !PROMOS_TO_HIDE.includes(tag.label));
};
